import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import '../../styles/PcMenu.css';

const PcMenu = ({ closeMenu }) => {
    // Accept closeMenu as a prop { closeMenu}
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, []);


    return (
        <ul className="pc-menu">
            {!isAuthenticated && (
                <li>
                    <NavLink
                        exact="true"
                        to="/"
                        className={({ isActive }) => (isActive ? "active-link" : undefined)}
                        onClick={closeMenu} // Close menu on click
                    >
                        Home
                    </NavLink>
                </li>
            )}

            <li>
                <NavLink
                    to="/about-us"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                    About Us
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="/contact-us"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                    Contact Us
                </NavLink>
            </li>

            <li>
                <NavLink
                    to="/investments"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                    Investments
                </NavLink>
            </li>

            {!isAuthenticated && (
                <>
                    <li>
                        <NavLink
                            to="/loans"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            Loans
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/login"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            My Account
                        </NavLink>
                    </li>
                </>
            )}

            {isAuthenticated && (
                <>
                    <li>
                        <NavLink
                            to="/terms"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            Terms & Conditions
                        </NavLink>
                    </li>
                </>
            )}
        </ul>
    );
};

export default PcMenu;
